import React from 'react';
import { Text, Flex } from 'rebass';
import { ZIndex } from '../common';

interface IProps {
  quizIndex: number;
  star: number;
  starRef: React.Ref<HTMLElement>;
  height: string;
}

export default function Header({ quizIndex, star, starRef, height }: IProps) {
  return (
    <Flex
      p="20px"
      justifyContent="space-between"
      fontSize="20px"
      style={{
        position: 'fixed',
        top: 0,
        width: window.innerWidth,
        height,
        zIndex: ZIndex.Header,
        color: 'white',
        backgroundColor: '#3A053A',
        borderBottom: '4px solid #802535',
      }}
    >
      <Text flex="1 0">
        리액트 퀴즈 {1 + Math.floor(quizIndex / 3)}-{(quizIndex % 3) + 1}
      </Text>
      <Text ref={starRef} flex="0 0 auto" textAlign="right">
        {star} / 9
      </Text>
    </Flex>
  );
}
